import React, { useEffect, useRef } from "react";
import axios from "axios";
import { useAuth } from "../../context/AuthContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const API = `${BACKEND_URL}/api`;
const MILESTONE_MINUTES = 15;
const VISITOR_ID_KEY = "qp_visitor_id";
const FIRST_VISIT_KEY = "qp_first_visit_at";
const MILESTONE_LOGGED_KEY = "qp_milestone_15min_logged";

const getOrCreateVisitorId = () => {
  let id = localStorage.getItem(VISITOR_ID_KEY);
  if (!id) {
    id = `visitor_${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
    localStorage.setItem(VISITOR_ID_KEY, id);
  }
  return id;
};

// Silently tracks the "first 15 minutes on site" engagement milestone (once per
// browser) and logs it to the backend, which appends a row to the owner's
// Google Sheet. No UI is shown to the visitor.
const EngagementTracker = () => {
  const { user } = useAuth();
  const intervalRef = useRef(null);

  useEffect(() => {
    if (localStorage.getItem(MILESTONE_LOGGED_KEY) === "true") return;

    let firstVisitAt = localStorage.getItem(FIRST_VISIT_KEY);
    if (!firstVisitAt) {
      firstVisitAt = Date.now().toString();
      localStorage.setItem(FIRST_VISIT_KEY, firstVisitAt);
    }

    const check = async () => {
      if (localStorage.getItem(MILESTONE_LOGGED_KEY) === "true") {
        clearInterval(intervalRef.current);
        return;
      }
      const elapsedMs = Date.now() - parseInt(firstVisitAt, 10);
      if (elapsedMs >= MILESTONE_MINUTES * 60 * 1000) {
        localStorage.setItem(MILESTONE_LOGGED_KEY, "true");
        clearInterval(intervalRef.current);
        try {
          await axios.post(`${API}/track/engagement-milestone`, {
            milestone: "first_15_minutes",
            visitor_id: getOrCreateVisitorId(),
            name: user?.name,
            email: user?.email,
          });
        } catch (e) {
          // silent - non-critical analytics call
        }
      }
    };

    intervalRef.current = setInterval(check, 30000);
    check();

    return () => clearInterval(intervalRef.current);
  }, [user]);

  return null;
};

export default EngagementTracker;
